<template lang="pug">
.form-method.center(:class="{'inside-padding': !fillData}")
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container
        input.input(v-model="dataForm.method" autocomplete="ño" :disabled="fillData" required)
        label.label(:class="{ show: dataForm.method }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="method" title="Método de Pago")

      .input-container
        input.input(v-model.number="dataForm.order" type="number" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.order }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="order" title="Orden")

      .input-container.arrow
        select.select(v-model="dataForm.type" autocomplete="ño" required)
          option.capitalize(v-for="type in types" :value="type") {{ type }}
        label.label(:class="{ show: dataForm.type }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="type" title="Tipo")

      .input-container
        input.input(v-model.number="dataForm.cost" min="0" max="20000" type="number" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.cost >= 0 }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="cost" title="Costo")

      .input-container.arrow
        select.select(v-model="dataForm.folder" autocomplete="ño" required)
          option(v-for="folder in folders" :value="folder") {{ folder }}
        label.label(:class="{ show: dataForm.folder }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="folder" title="Carpeta")

      shInputImage(:dataForm="dataForm" :dataOriginal="dataOriginal" title="Imagen" property="image" :folder="dataForm.folder" @load="imageLoaded = true" @error="imageLoaded =  false" :noImagePath="noImagePathMethod" :classContainerImage="classContainerImage" :imagePath="imagePath" :required="1")

      .left
        h3 Activo en Marca

      .input-container.arrow(v-for="(brand, index) in brands")
        select.select(v-model="dataForm.activeMethod[index]" autocomplete="ño" required)
          option(:value="true") Activo
          option(:value="false") Inactivo
        label.label(:class="{ show: dataForm.activeMethod[index] }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="activeMethod" :index="index" :title="brand")

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteMethod")
</template>

<script>
import mForm from '@/mixins/form'
import mDB from '@/mixins/db'
import gqlMethod from '@/graphql/method'

export default {
  name: 'FormMethod',

  mixins: [mForm, mDB],

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        method: '',
        image: '',
        folder: '',
        order: '',
        cost: '',
        type: '',
        activeMethod: []
      },
      resolver: 'method',
      key: 'method',
      gql: gqlMethod,
      imageLoaded: false,
      classContainerImage: 'button-method',
      types: ['creditcard', 'cash', 'manual', 'pse', 'money', 'others']
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  methods: {
    sendForm () {
      if (this.imageLoaded) {
        if (!this.fillData) {
          this.newMethod()
        } else {
          this.updateMethod()
        }
      }
    },

    newMethod () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateMethod () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteMethod () {
      this.deleteData(this.gql, this.resolver, this.key)
    }
  },

  computed: {
    folders () {
      return this.$store.state.folders
    },
    brands () {
      return this.$store.state.variables.brands
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-method
  position relative

.button-method
  border none
  border-radius 1em
  //borderRadius(.8em)
  font-size 1.2em
  font-weight 600
  transition all .2s ease-in
  box-shadow 0px 0px 20px -2px rgba(0, 0, 0, .9)
  display inline-flex
  padding 1em 1.5em
  justify-content space-around
  //boxShadow(0px 8px 20px -2px rgba(0, 0, 0, .9))

.button-method:hover
  box-shadow 0px 0px 20px -2px #ffdc65

.button-method img
  align-self center
  height 2em
</style>



// WEBPACK FOOTER //
// src/components/pages/method/Form.vue